import styled from 'styled-components';

const StyledToggleButton = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  position: absolute;
  z-index: -1; // Ensures that the label text is on top and clickable

  & + label {
    position: ${({ styling }) => `${styling.togglePosition}`};
    right: 0;
    cursor: pointer;
    width: ${({ styling }) => `${styling.toggleWidth}px`};
    height: ${({ styling }) => `${styling.toggleHeight}px`};
    background-color: ${({ styling }) => styling.toggleBackgroundColor};
    border: ${({ styling }) => `${styling.toggleBorderWidth}px solid ${styling.toggleBorderColor}`};
    border-radius: ${({ styling }) => `${styling.toggleBorderRadius}px`};
    transition: background-color .25s;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: ${({ styling }) => `${styling.toggleMarginRight}px`};
    padding: ${({ styling }) => `${styling.togglePadding}px`};
    box-sizing: content-box;

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: ${({ styling }) => `${styling.toggleKnobAlignment}px`};
      width: ${({ styling }) => `${styling.toggleKnobWidth}px`};
      height: ${({ styling }) => `${styling.toggleKnobHeight}px`};
      background-color: ${({ styling }) => styling.toggleKnobColor};
      border-radius: 50%;
      transform: translateY(-50%);
      transition: left .25s, background-color .25s;
    }
  }

  &:checked + label {
    background-color: ${({ styling }) => styling.toggleCheckedBackgroundColor};
  }

  &:checked + label:after {
    left: calc(100% - ${({ styling }) => `${styling.toggleKnobWidth}px`} - ${({ styling }) => `${styling.toggleKnobAlignment}px`});
    background-color: ${({ styling }) => styling.toggleKnobCheckedColor};
  }
`;

export default StyledToggleButton;